/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAccountShowBusinessProfilePathParams,
	WhatsAppAccountShowBusinessProfileResponse,
} from '../types/WhatsAppAccountShowBusinessProfile'

/**
 * GET /organisations/:organisationId/whatsapp-account/business-profile
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::showBusinessProfile
 */
export async function whatsAppAccountShowBusinessProfile(
	organisationId: WhatsAppAccountShowBusinessProfilePathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAccountShowBusinessProfileResponse>> {
	return axiosInstance.get(`/organisations/${organisationId}/whatsapp-account/business-profile`, config)
}
